import { reduce } from "lodash";

import { GET_MAPPINGS } from "./mappingsTab/gql";
import { MAPPING_LEVELS } from "./constants";
import { showInfoToast, showSuccessToast } from "@src/appV2/lib/Notifications";

const ACTION_TYPE = {
  ADDED: "ADDED",
  DELETED: "DELETED",
  UPDATED: "UPDATED",
};

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const unwindLevels = (levels: any) => {
  const map = {
    [MAPPING_LEVELS.GLOBAL]: [MAPPING_LEVELS.GLOBAL],
    [MAPPING_LEVELS.LOCATION]: [MAPPING_LEVELS.STATE, MAPPING_LEVELS.MSA, MAPPING_LEVELS.COUNTY],
    [MAPPING_LEVELS.HCF]: [MAPPING_LEVELS.HCF],
  };
  // FIXME: Automatically disabled during ESLint config update
  // @ts-expect-error TODO(typecheck-unify): TS7053 Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ GLOBAL: "GLOBAL"[]; LOCATION: ("COUNTY"
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return reduce(levels, (res, type) => [...res, ...map[type]], [] as any[]);
};

const updateMappingsCache =
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element '_id' implicitly has an 'any' type.
  ({ _id, actionType, filter, hcfId }) =>
    // @ts-expect-error TODO(typecheck-unify): TS7006,TS7031 Parameter 'cache' implicitly has an 'any' type.
    (cache, { data: modifiedData }) => {
      const data = cache.readQuery({
        query: GET_MAPPINGS,
        variables: { hcfId, levels: unwindLevels(filter) },
      });
      let updatedData = [...data.mappings];
      const incoming =
        modifiedData.createRequirementMapping ||
        modifiedData.updateRequirementMapping ||
        modifiedData.deleteRequirementMapping;
      let insert = true;

      // Check if we have to replace a mapping (due it it being an edited or merged mapping)
      if (actionType !== ACTION_TYPE.DELETED) {
        const message = `We're going to merge the mapping into an existing one at ${incoming.level} level`;
        // A merging occurred during update
        if (_id && incoming._id !== _id) {
          // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'mapping' implicitly has an 'any' type.
          updatedData = data.mappings.filter((mapping) => mapping._id !== _id);
          showInfoToast(message);
        }
        // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'mapping' implicitly has an 'any' type.
        updatedData = data.mappings.map((mapping) => {
          if (mapping._id === incoming._id) {
            insert = false;
            return incoming;
          }

          return mapping;
        });

        // A merging occurred during insertion
        if (!_id && !insert) {
          showSuccessToast(message);
        }

        // If mapping wasn't inserted already, it's a new one.
        if (insert) {
          updatedData.push(incoming);
        }
      } else {
        const indexToRemove = updatedData.findIndex((mapping) => mapping._id === incoming);

        updatedData.splice(indexToRemove, 1);
      }

      cache.writeQuery({
        query: GET_MAPPINGS,
        data: { ...data, mappings: updatedData },
      });
    };

export { ACTION_TYPE, updateMappingsCache, unwindLevels };
